var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "page" }, [
      _c("div", { staticClass: "loader is-visible" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }